import readFile from "@/readFile";
import {callApi} from "@/api";
import LicenseParseResult from "@/models/LicenseParseResult";

/**
 *
 * @param {City} city
 * @param {File} file
 * @return {Promise<LicenseParseResult>}
 */
export async function parseLicenses(city, file) {
  const {input,format} = await readFile(file);
  const data = await callApi('importLicenses', {
    cityId: city.id,
    input,
    format,
    excludeLicensesFromOutput: false,
    excludeUnchangedFromOutput: false
  }, 'data');
  return new LicenseParseResult(city, data);
}
